import { render, staticRenderFns } from "./AudioVizualizer.vue?vue&type=template&id=8b7bdb16&scoped=true&"
import script from "./AudioVizualizer.vue?vue&type=script&lang=js&"
export * from "./AudioVizualizer.vue?vue&type=script&lang=js&"
import style0 from "./AudioVizualizer.vue?vue&type=style&index=0&id=8b7bdb16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7bdb16",
  null
  
)

export default component.exports